module.exports = __webpack_public_path__ + "img/icon_kmsdgfzvip.4397764f.png";